import { Injectable, ModuleWithProviders, NgModule } from '@angular/core';
import { LoaderComponent } from './loader/loader.component';
import { CommonModule, DatePipe, DecimalPipe } from '@angular/common';
import { localStorageService } from './localstorage.service';
import { RouterModule } from '@angular/router';
// import { ModalModule } from 'ngx-bootstrap/modal';
import { NgxSelectModule, INgxSelectOptions } from 'ngx-select-ex';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { PaymentTableComponent } from './payment-table/payment-table.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ProgressbarModule } from 'ngx-bootstrap/progressbar';
import { GoogleZipComponent } from './google-zip/google-zip.component';
import { NgxGpAutocompleteModule } from '@angular-magic/ngx-gp-autocomplete';
import { Loader } from '@googlemaps/js-api-loader';
import { ViewNotesComponent } from './view-notes/view-notes.component';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { SpecialNoteComponent } from './special-note/special-note.component';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import { PaginationModule } from 'ngx-bootstrap/pagination';
import { NgxEditorModule } from 'ngx-editor';
import { HttpClientModule } from '@angular/common/http';
import { FiltersComponent } from './filters/filters.component';
import { AddNotesComponent } from './add-notes/add-notes.component';
import { EditContractModalComponent } from './edit-contract-modal/edit-contract-modal.component';
import { GenerateStripeElementComponent } from './generate-stripe-element/generate-stripe-element.component';
import { CommonNotesListingComponent } from './common-notes-listing/common-notes-listing.component';
import { NotesListComponent } from './hidden-notes/notes-list/notes-list.component';
import { AddNoteComponent } from './hidden-notes/add-note/add-note.component';
import { AssignmentTabsComponent } from './assignment-tabs/assignment-tabs.component';
import { EditorCodemirrorComponent } from './editor-codemirror/editor-codemirror.component';
import { UpdateCustomerModalComponent } from './customer-update/customer-update.component';
import { AddEditTrainingComponent } from './add-edit-training/add-edit-training.component';
import { BsModalService, ModalModule } from 'ngx-bootstrap/modal';
import { ChatSupportComponent } from './chat-support/chat-support.component';
// import { SupportChatComponent } from '../pages/support-chat/support-chat.component';
import { InfiniteScrollDirective } from 'ngx-infinite-scroll';
import { CsrRequestModalComponent } from './csr-request-modal/csr-request-modal.component';
// import { ModalModule } from 'ngx-bootstrap/modal';
import { DropdownModule } from 'primeng/dropdown';
import { CalendarModule } from 'primeng/calendar';
import { SendSmsComponent } from './send-sms/send-sms.component';
import { ToastrService } from 'ngx-toastr';
import { CodemirrorModule } from '@ctrl/ngx-codemirror';
import { ProfileImageModalComponent } from './profile-image-modal/profile-image-modal.component';
import { HighlightPipe } from './highlight.pipe';
import { SortKeyValuePipe } from './sortKeyValue.pipe';
import { TloDataComponent } from './tlo-data/tlo-data.component';
import { AccordionModule } from 'ngx-bootstrap/accordion';
import { ImageCropperComponent } from 'ngx-image-cropper';
import { NotificationsComponent } from './notifications/notifications.component';
import { AssignmentDetailsComponent } from '../pages/assignments/assignment-details/assignment-details.component';
import { TrainingDetailsComponent } from '../pages/training/training-details/training-details.component';
import { AssignmentsModalComponent } from '../pages/assignments/assignments-modal/assignments-modal.component';
import { SearchDetailsComponent } from './main-layout/search-details/search-details.component';
import { CurrencyFormatPipe } from './shared.service';
import { MaskSensitivePipe,PhoneFormatPipe, SafeExternalLinksDirective,CountryPhonePipe } from './shared.service';
import { CallingComponent } from './calling/calling.component';
import { DialComponent } from './dial/dial.component';
import { CallScriptComponent } from './call-script/call-script.component';

const CustomSelectOptions: INgxSelectOptions = {
  // Check the interface for more options
  optionValueField: 'id',
  optionTextField: 'name',
};

@Injectable({
  providedIn: 'root',
})
@NgModule({
  declarations: [
    LoaderComponent,
    PaymentTableComponent,
    GoogleZipComponent,
    ViewNotesComponent,
    SpecialNoteComponent,
    FiltersComponent,
    AddNotesComponent,
    EditContractModalComponent,
    GenerateStripeElementComponent,
    CommonNotesListingComponent,
    NotesListComponent,
    AddNoteComponent,
    AssignmentTabsComponent,
    EditorCodemirrorComponent,
    UpdateCustomerModalComponent,
    AddEditTrainingComponent,
    // SupportChatComponent,
    ChatSupportComponent,
    SendSmsComponent,
    CsrRequestModalComponent,
    ProfileImageModalComponent,
    HighlightPipe,
    SortKeyValuePipe,
    TloDataComponent,
    NotificationsComponent,
    AssignmentDetailsComponent,
    AssignmentsModalComponent,
    TrainingDetailsComponent,
    SearchDetailsComponent,
    CurrencyFormatPipe,
    PhoneFormatPipe,
    CountryPhonePipe,
    MaskSensitivePipe,
    CallingComponent,
    SafeExternalLinksDirective,
    DialComponent,
    CallScriptComponent
  ],
  imports: [
    CommonModule,
    DatePipe,
    NgxMaskDirective,
    RouterModule,
    FormsModule,
    NgxSelectModule.forRoot(CustomSelectOptions),
    BsDatepickerModule.forRoot(),
    PopoverModule.forRoot(),
    TooltipModule.forRoot(),
    ReactiveFormsModule,
    ProgressbarModule.forRoot(),
    NgxGpAutocompleteModule,
    BsDropdownModule,
    NgxMaskDirective,
    NgxMaskPipe,
    PaginationModule,
    HttpClientModule,
    InfiniteScrollDirective,
    ModalModule.forRoot(),
    DropdownModule,
    CalendarModule,
    NgxEditorModule.forRoot({
      locals: {
        // menu
        bold: 'Bold',
        italic: 'Italic',
        code: 'Code',
        underline: 'Underline',
        strike: 'Strike',
        blockquote: 'Blockquote',
        bullet_list: 'Bullet List',
        ordered_list: 'Ordered List',
        heading: 'Heading',
        h1: 'Header 1',
        h2: 'Header 2',
        h3: 'Header 3',
        h4: 'Header 4',
        h5: 'Header 5',
        h6: 'Header 6',
        align_left: 'Left Align',
        align_center: 'Center Align',
        align_right: 'Right Align',
        align_justify: 'Justify',
        text_color: 'Text Color',
        background_color: 'Background Color',
    
        // pupups, forms, others...
        url: 'URL',
        text: 'Text',
        openInNewTab: 'Open in new tab',
        insert: 'Insert',
        altText: 'Alt Text',
        title: 'Title',
        remove: 'Remove',
      },
    }),
    ImageCropperComponent,
    CodemirrorModule,
    AccordionModule
  ],
  providers: [
    localStorageService,
    DatePipe,
    DecimalPipe,
    BsModalService,
    provideNgxMask(),
    {
      provide: Loader,
      useValue: new Loader({
        apiKey: window.location.href.includes('.recuvery.com')
          ? 'AIzaSyDuayE9g_ErYJHUDNwcELxOoaiidjG4E2k'
          : 'AIzaSyAudUxsyfqNreXJdNllGSnMiyWZqdZHF-I',
        libraries: ['places'],
      }),
    },
  ],
  exports: [
    LoaderComponent,
    NgxSelectModule,
    BsDatepickerModule,
    PopoverModule,
    TooltipModule,
    PaymentTableComponent,
    NgxGpAutocompleteModule,
    GoogleZipComponent,
    ViewNotesComponent,
    BsDropdownModule,
    SpecialNoteComponent,
    NgxMaskDirective,
    NgxMaskPipe,
    PaginationModule,
    NgxEditorModule,
    ModalModule,
    FiltersComponent,
    AddNotesComponent,
    EditContractModalComponent,
    GenerateStripeElementComponent,
    CommonNotesListingComponent,
    NotesListComponent,
    AddNoteComponent,
    AssignmentTabsComponent,
    EditorCodemirrorComponent,
    AddEditTrainingComponent,
    ChatSupportComponent,
    SendSmsComponent,
    CsrRequestModalComponent,
    InfiniteScrollDirective,
    FormsModule,
    ProfileImageModalComponent,
    HighlightPipe,
    SortKeyValuePipe,
    TloDataComponent,
    NotificationsComponent,
    AssignmentDetailsComponent,
    AssignmentsModalComponent,
    CurrencyFormatPipe,
    PhoneFormatPipe,
    CountryPhonePipe,
    MaskSensitivePipe,
    CallingComponent,
    SafeExternalLinksDirective,
    DialComponent,
    CallScriptComponent
  ],
})
export class SharedModule {
  static forRoot(): ModuleWithProviders<SharedModule> {
    return {
      ngModule: SharedModule,
    };
  }
}
